import { memo } from 'react';
import { StepViewComponent } from '../stepDescriptor/types';
import { Instruction } from './Instruction';

export const InstructionPinnedViewComponent: StepViewComponent = memo(
  ({ complete, responseIndex, readOnly }) => {
    return (
      <Instruction complete={complete} responseIndex={responseIndex} readOnly={readOnly} isPinned />
    );
  },
);
